import { IconList, Strong } from '@ahmdigital/ui';
import { PRODUCT_LIMIT_CATEGORY } from '@ahmdigital/constants';
import styled from 'styled-components';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled(Strong)`
  margin-bottom: 1rem;
`;

const content = [
  {
    id: PRODUCT_LIMIT_CATEGORY.TEETH,
    items: [
      {
        icon: 'arrow-right-long',
        text: 'Orthodontics with an $1,800 lifetime limit',
      },
      { icon: 'arrow-right-long', text: 'Increased bundle limit to $800' },
      { icon: 'arrow-right-long', text: 'Increased benefit back to 60%' },
    ],
    title: 'Add another bundle to increase your inclusions, limits and percentage back',
  },
];

const ExtraDetailsSection = ({ id }: { id: string }) => {
  const extraDetails = content.find((item) => item.id === id);

  if (!extraDetails) {
    return null;
  }

  const { items, title } = extraDetails;

  return (
    <StyledContent>
      <StyledTitle>{title}</StyledTitle>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ icon: string; text: string; }[]' is not assignable to type 'IconListItem[]'. */}
      <IconList variant="simple" iconSize="extraSmall" items={items} />
    </StyledContent>
  );
};

export default ExtraDetailsSection;
